import { render, staticRenderFns } from "./WeeklyYield.vue?vue&type=template&id=5c13e2ae&scoped=true&"
import script from "./WeeklyYield.vue?vue&type=script&lang=js&"
export * from "./WeeklyYield.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyYield.vue?vue&type=style&index=0&id=5c13e2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13e2ae",
  null
  
)

export default component.exports